export const APPLICATION_EMBED_CATEGORY_KEY = 'base' as const;
export const APPLICATION_EMBED_COMPONENT_KEY = 'applicationEmbed' as const;
